export default class Excerpt {
	constructor() {
		this.node = document.querySelectorAll('.excerpt__link');

		if (!this.node) {
			return;
		}

		this.node.forEach((node) => {
			node.addEventListener("mouseenter", function () {
				this.closest('.excerpt').classList.add('is-hovered');
			});

			node.addEventListener("mouseout", function () {
				this.closest('.excerpt').classList.remove('is-hovered');
			});
		});
	}

};



